<template>
  <cross-entities-loader :entityCode="entityCode" :entityId="entityId" v-model="entityRelations" v-slot:default="{ loading /*, errors */ }">
    <div v-if="loading" class="flex justify-start items-center h3">
      <content-spinner class="ml4"/>
    </div>
    <div v-else class="entities-breadcrumb-layout mw6 h3">
      <template v-for="(crumb, index) in breadcrumbs">
        <div :key="index">
          <div v-if="relationsCount(crumb) > 1" class="entities-breadcrumb-item">
            {{ crumb.labels }}
          </div>
          <router-link v-else-if="relationsCount(crumb) === 1" :to="{ name: crumb.card_route, params: { id: crumb.relations[0] } }"
            class="entities-breadcrumb-item link"
            :class="{ 'entities-breadcrumb-active': crumb.code === entityCode }">
            <div>{{ crumb.label }}</div>
            <div>{{ crumb.relations[0] }}</div>
          </router-link>
          <div v-else class="entities-breadcrumb-disabled">
            {{ crumb.labels }}
          </div>
        </div>
        <div v-if="index < breadcrumbs.length - 1" :key="1000 + index" class="entities-breadcrumb-delimeter"></div>
      </template>
    </div>
  </cross-entities-loader>
</template>

<script>
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import CrossEntitiesLoader from '@/components/common/CrossEntitiesLoader.vue'

export default {
  components: {
    CrossEntitiesLoader,
    ContentSpinner
  },
  props: ['entityCode', 'entityId'],
  data () {
    return {
      entityRelations: null
    }
  },
  computed: {
    breadcrumbs () {
      return [{
        code: 'claim',
        card_route: 'claim_card',
        relations: this.entityRelations.claim,
        label: 'Заявка',
        labels: 'Заявки'
      }, {
        code: 'procedure',
        card_route: 'procedure_card',
        relations: this.entityRelations.procedure,
        label: 'Торги',
        labels: 'Торги'
      }, {
        code: 'contract',
        card_route: 'contract_card',
        relations: this.entityRelations.contract,
        label: 'Договор',
        labels: 'Договоры'
      }, {
        code: 'order',
        card_route: 'order_card',
        relations: this.entityRelations.order,
        label: 'Заказ',
        labels: 'Заказы'
      }]
    }
  },
  methods: {
    getEntity (code) {
      return this.entities.items.find(entity => entity.code === code)
    },
    relationsCount (crumb) {
      return Array.isArray(crumb.relations) ? crumb.relations.length : 0
    },
    forwardTo (entity) {
      if (entity.action) {
        entity.action()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.entities-breadcrumb-layout {
  display: grid;
  grid-template-columns: 9fr 0px  9fr 0px 11fr 0px 10fr;
  grid-template-rows: auto;
  align-items: center;
  justify-items: stretch;
  grid-column-gap: 0;
  grid-row-gap: 0;
}
.entities-breadcrumb-delimeter {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-left: 6px solid #BCCCDC; //9FB3C8
  border-bottom: 4px solid transparent;
  z-index: 10;
  -moz-transform: translateX(-1px);
  -ms-transform: translateX(-1px);
  -webkit-transform: translateX(-1px);
  transform: translateX(-1px);
}
.entities-breadcrumb-item {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  align-items: center;
  justify-items: center;
  grid-column-gap: 0;
  grid-row-gap: .15rem;
  font-size: .75rem;
  text-transform: uppercase;
  background-color: transparent;
  color: #627D98;
  font-weight: 400;
  padding-top: .25rem;
  padding-bottom: .25rem;
  cursor: pointer;
}
.entities-breadcrumb-disabled {
  @extend .entities-breadcrumb-item;
  background-color: transparent;
  color: #BCCCDC;
  cursor: default;
}
.entities-breadcrumb-active {
  color: #F9703E;
}
</style>
